<template>
  <div class="yh-page">
    <el-card>
      <el-collapse v-model="activeNames">
      <el-collapse-item title="基础信息" name="1">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px" v-loading="loading" :element-loading-text="loadingText">
        <el-row>
        <el-col :span="16">
          <el-row>
            <el-col :span="9">
              <el-form-item label="报名活动" prop="activity">
                <el-select v-model="form.activity" placeholder="请选择活动" filterable @change="handleAtvInfo" value-key="id" :disabled="!canEditActivity">
                  <el-option v-for="at in activities" :key="at.id"
                      :label="at.year + '年' + at.activity_periods +'  保险期限:' + at.insurance_begin_date + '至' + at.insurance_end_date" :value="at.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="业务归属部门" prop="department">
                <el-select v-model="form.department" placeholder="请选择部门" filterable value-key="id"  style="width: 48%;">
                  <el-option v-for="g in groupList" :key="g.id"
                      :label="g.name" :value="g.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="9">
            <el-form-item label="会员信息" prop="customer">
              <el-select v-model="form.customer" placeholder="请选择会员"
              filterable @change="handleCustomerInfo" value-key="id"
              remote :remote-method="remoteCustomerMethod" :loading="customer_loading"
              :disabled="canEditFinance"
              >
                <el-option v-for="c in customers" :key="c.id"
                    :label="c.name" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否会员">
              <el-input v-model="is_member_name" style="width: 64%;" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="is_correct">
          <el-col :span="9">
            <el-form-item label="原会员信息">
              <span :style="form.customer === parent_form.customer ? '' : 'color: red'">{{ parent_form.customer_name }}</span>
            </el-form-item>
          </el-col>
        </el-row>

          <el-form-item label="会员到期日" v-if="is_member">
            <el-input placeholder="会员到期日" v-model="expire_date" style="width: 64%;" disabled/>
          </el-form-item>

          <el-row>
            <el-col :span="9">
              <el-form-item label="船舶信息" prop="ship">
                <el-select v-model="form.ship" placeholder="请选择船舶"
                  filterable @change="handleShipInfo" value-key="id"
                  remote :remote-method="remoteShipMethod" :loading="ship_loading"
                  :disabled="canEditFinance"
                >
                  <el-option v-for="s in ships" :key="s.id"
                      :label="s.name" :value="s.id"></el-option>
                </el-select>
                <!--<span style="margin-left: 60px">缴费总吨：{{ form.pay_gross_ton }}</span>-->
              </el-form-item>
            </el-col>

            <el-col :span="9">
              <el-form-item label="缴费总吨" prop="pay_gross_ton">
                <el-input type="number" min="0" v-model="form.pay_gross_ton" style="width: 48%;" :disabled="canEditFinance"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="is_correct">
            <el-col :span="9">
              <el-form-item label="原船舶信息">
                <span :style="form.ship === parent_form.ship ? '' : 'color: red'">{{ parent_form.ship_name }}</span>
              </el-form-item>
            </el-col>

            <el-col :span="9">
              <el-form-item label="原缴费总吨" prop="pay_gross_ton">
                <span :style="form.pay_gross_ton === parent_form.pay_gross_ton ? '' : 'color: red'">{{ parent_form.pay_gross_ton }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <el-form-item label="入会日期" prop="join_date">
                <el-date-picker type="date" placeholder="选择日期" v-model="form.join_date"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入会会费" prop="dues">
                <el-input type="number" min="0" v-model="form.dues" style="width: 48%;" :disabled="canEditFinance"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <el-form-item label="业务归属部门" prop="department">
                <el-select v-model="form.department" placeholder="请选择部门" filterable value-key="id">
                  <el-option v-for="g in groupList" :key="g.id"
                      :label="g.name" :value="g.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 推荐人 -->
              <el-form-item label="推荐人" prop="referee">
                <el-tooltip class="item" effect="dark" content="业务归属人或代理人" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <el-select v-model="form.referee" filterable placeholder="请选择推荐人" style="width: 48%;">
                  <el-option
                      v-for="(user, index) in user_list"
                      :key="index"
                      :label="user.first_name"
                      :value="user.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <el-form-item label="参与年限" prop="append_date">
                  第 <el-input type="number" placeholder="选择年限" min="1" v-model="form.append_date" style="width: 65%;"/> 年参加
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="系统风险准备金余额" v-show="opera_type !== 'ViewApply'">
                <el-input type="number" v-model="sys_balance" disabled style="width: 75%;">
                  <template slot="append">
                    <el-tooltip effect="light" content="将当前值填入本期风险准备金" placement="top-start">
                      <el-button icon="el-icon-bottom" @click="useSysBalance" :disabled="canEditFinance"></el-button>
                    </el-tooltip>
                  </template>
                </el-input> 元
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="上期风险准备金余额">
                <el-input type="number" v-model="form.balance" disabled style="width: 48%;" />
                <el-tooltip v-if="form.balance !== sys_balance" class="item" effect="dark" content="风险准备金余额与系统存在差异将无法提交审核" placement="top-start">
                  <i style="color: #E6A23C;" class="el-icon-warning"></i>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="风险准备金方案">
                <el-select v-model="form.risk_premium_plans" placeholder="请选择风险准备金方案">
                  <el-option v-for="item in risk_premium_plan_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="系统计算风险准备金" v-show="opera_type !== 'ViewApply'">
                <el-input placeholder="输入风险准备金金额" type="number" v-model="payable_risk_premium" disabled :controls="false" style="width: 60%;">
                  <template slot="append">
                    <el-tooltip effect="light" content="将当前值填入本期风险准备金" placement="top-start">
                      <el-button icon="el-icon-bottom" @click="usePayableRiskPremium" :disabled="canEditFinance"></el-button>
                    </el-tooltip>
                  </template>
                </el-input> 元
                ({{ form.risk_premium_plans ? risk_premium_plan_list.find(plan => plan.id == form.risk_premium_plans).rate : 0 }} 元/总吨)
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="差异">
                <el-input type="number" v-model="diff_premium" style="width: 48%;" disabled/> 元
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="本期风险准备金">
                <el-input placeholder="输入风险准备金金额" type="number" v-model="risk_premium" :controls="false" style="width: 20%;" :disabled="canEditFinance"/> 元
                ({{ risk_rate ? risk_rate : 0 }} 元/总吨)
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="风险准备金基数">
                <el-input type="number" v-model="risk_rate" style="width: 48%;" disabled/>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="最高赔偿限额">
                <el-select v-model="max_compensation" placeholder="请选择最高赔偿限额" @change="handleMaxCompensationChange">
                  <el-option
                    v-for="(item, index) in max_compensation_choice"
                    :key="'max_compensation_' + index"
                    :value="item">
                  </el-option>
                </el-select>
                <span v-if="show_computed_value">({{ max_compensation_value }} 万元)</span>
                <span v-else>({{ form.max_compensation_value ? form.max_compensation_value : max_compensation_value }} 万元)</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="大桥险费率">
            <el-select v-model="big_rate" placeholder="请选择大桥险费率">
              <el-option v-for="item in big_rate_items" :key="item" :label="item" :value="item"></el-option>
            </el-select> 元/总吨
            <!-- <el-input type="number" placeholder="选择年限" v-model="big_rate" style="width: 19%;" disabled/> 元/总吨 -->
          </el-form-item>
          <el-form-item label="保险期限(大桥)">
            <el-col :span="16">
              <el-date-picker type="date" placeholder="选择日期" v-model="form.big_begin_date" style="width: 46%;" :disabled="!is_correct" value-format="yyyy-MM-dd" @change="handleChangeBigBeginDate"></el-date-picker>
              至
              <el-date-picker type="date" placeholder="选择日期" v-model="form.big_end_date" style="width: 46%;" disabled></el-date-picker>
            </el-col>
            <el-col :span="2" v-if="JSON.stringify(this.select_atv) !== '{}'">
              <span>共 {{ big_ins_period }} 天</span>
            </el-col>
          </el-form-item>
          <el-form-item label="被保险人">
            <el-input placeholder="被保险人名称" v-model="form.insured" style="width: 64%;"/>
          </el-form-item>
          <el-form-item label="原被保险人" v-if="is_correct">
            <span :style="form.insured === parent_form.insured ? '' : 'color: red'">{{ parent_form.insured }}</span>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="9">
              <el-form-item label="联系人">
                <el-select v-model="form.contact" placeholder="请选择联系人" remote filterable value-key="id" :loading="contact_loading" :remote-method="remoteContactMethod">
                  <el-option v-for="(g, index) in contact_list" :key="index" 
                      :label="g.name" :value="g.name" @click.native="handleContactInfo(index)"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="联系电话">
                <!-- <el-input placeholder="联系电话" v-model="form.contact_mobile" disabled/> -->
                <span>{{restricted_mobile(form.contact_mobile)}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" size="small" @click="handCreateContact">新增联系人</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="备注" label-width="120px">
                <el-input type="textarea" v-model="form.content"  width="50%"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="大桥批改内容" label-width="120px" v-if="is_correct">
                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" width="50%"
                v-model="form.change_content"
                placeholder="格式如本保单第一收益人由“XXXX”变更为“XXXXXXX”，无修改不填"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="小桥批改内容" label-width="120px" v-if="is_correct">
                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" width="50%"
                v-model="form.small_change_content"
                placeholder="格式如本保单第一收益人由“XXXX”变更为“XXXXXXX”，无修改不填"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <el-form-item label="是否购买小桥险">
                <el-switch v-model="delivery" @change="handleSmallInfo" :disabled="canEditFinance"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="delivery">
              <el-form-item label="小桥险保费(元/年)">
                <el-select v-model="form.small_rate" placeholder="请选择小桥方案" style="width: 48%;" :disabled="canEditFinance">
                  <el-option v-for="r in small_rates" :key="r.index"
                      :label="r" :value="r"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="保险期限(小桥)" v-show="delivery">
            <el-col :span="16">
              <el-date-picker type="date" placeholder="选择日期" v-model="form.small_begin_date" style="width: 46%;"></el-date-picker>
              至
              <el-date-picker type="date" placeholder="选择日期" v-model="form.small_end_date" style="width: 46%;"></el-date-picker>
            </el-col>
            <el-col :span="2">
              <span>共 {{ small_ins_period }} 天</span>
            </el-col>
          </el-form-item>
        </el-col>


        <el-col :span="8">
          <div style="background-color: orange;">
            <h5><center>船舶信息</center></h5>
          </div>
          <el-form-item label="船籍港">
            <el-input  v-model="ship_info.reg_port" style="width: 64%;"/>
            <el-tooltip v-show="!ship_info.reg_port" class="item" effect="dark" content="船舶信息不完整将无法提交审核" placement="top-start">
              <i style="color: #E6A23C;" class="el-icon-warning"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="船舶识别号/登记号">
            <el-input  v-model="ship_info.id_code" style="width: 64%;"  disabled/>
            <el-tooltip v-show="!ship_info.id_code" class="item" effect="dark" content="船舶信息不完整将无法提交审核" placement="top-start">
              <i style="color: #E6A23C;" class="el-icon-warning"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="总吨位">
            <el-input  v-model="ship_info.gross_tonnage" style="width: 64%;" disabled/>
            <el-tooltip v-show="!ship_info.gross_tonnage" class="item" effect="dark" content="船舶信息不完整将无法提交审核" placement="top-start">
              <i style="color: #E6A23C;" class="el-icon-warning"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="船舶类型" prop="type">
              <el-select  class="filter-item"  filterable
                         placeholder="请选择适合区域" style="width: 64%;" v-model="ship_info.ship_type"  >
                <el-option v-for="(type, index) in type_list" :key="index" :label="type.value" :value="type.code">
                </el-option>
              </el-select>
              <el-tooltip v-show="!ship_info.ship_type" class="item" effect="dark" content="船舶信息不完整将无法提交审核" placement="top-start">
                <i style="color: #E6A23C;" class="el-icon-warning"></i>
              </el-tooltip>
          </el-form-item>
          <el-form-item label="建造完工日期" prop="construct_date">
              <el-date-picker v-model="ship_info.construct_date"
                              type="date" value-format="yyyy-MM-dd"
                              placeholder="请选择建造完工日期" style="width: 64%;"></el-date-picker>
              <el-tooltip v-show="!ship_info.construct_date" class="item" effect="dark" content="船舶信息不完整将无法提交审核" placement="top-start">
                <i style="color: #E6A23C;" class="el-icon-warning"></i>
              </el-tooltip>
            </el-form-item>
          <el-form-item label="航区分类" prop="airworthiness_area">
              <el-select class="filter-item" v-model="ship_info.airworthiness_area" filterable
                         placeholder="请选择适合区域" style="width: 64%;">
                <el-option v-for="(area, index) in airworthiness_area_list" :key="index" :label="area.value"
                           :value="area.code">
                </el-option>
              </el-select>
              <el-tooltip v-show="!ship_info.airworthiness_area" class="item" effect="dark" content="船舶信息不完整将无法提交审核" placement="top-start">
                <i style="color: #E6A23C;" class="el-icon-warning"></i>
              </el-tooltip>
            </el-form-item>
          <div style="background-color: orange;">
            <h5><center>选择开票情况</center></h5>
          </div>
          <el-form-item label="开票情况：" prop="remark">
            <el-select v-model="form.remark.content" placeholder="请选择" style="width: 300px" :disabled="canEditFinance">
              <el-option
                v-for="item in invoice_items"
                :key="item.index"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <br/>
          <div style="background-color: orange;">
            <h5><center>相关费用如下</center></h5>
          </div>
          <el-form-item label="大桥险保费(元)：">
            {{ big_premium }}
          </el-form-item>
          <el-form-item label="本期风险准备金(元)：">
            {{ risk_premium }}
          </el-form-item>
          <el-form-item label="小桥险保费(元)：">
            {{ small_premium }}
          </el-form-item>
          <el-form-item label="入会会费(元)：">
            {{ form.dues }}
          </el-form-item>
          <hr/>
          <el-form-item label="收费合计(元)：">
            {{ total_amount }}
          </el-form-item>
          <br/>
          <div style="background-color: orange;">
            <h5><center>文件清单</center></h5>
          </div>
          <el-checkbox-group 
            v-model="checked_file_list"
            disabled
          >
            <el-checkbox v-for="file in must_file_list" :label="file.name" :key="file.name">{{file.name}}</el-checkbox>
          </el-checkbox-group>
          <el-tooltip v-show="!checked_must_file" class="item" effect="dark" content="文件清单不完整将无法提交审核" placement="top-start">
            <i style="color: #E6A23C;" class="el-icon-warning"></i>
          </el-tooltip>
          <template v-if="!form.is_verify_file">
            <br/>
            <div style="background-color: orange;">
              <h5><center>文件校验信息</center></h5>
            </div>
            <el-input readonly v-model="form.verify_file_msg" type="textarea" :autosize="{ minRows: 6, maxRows: 12 }"></el-input>
          </template>
        </el-col>
        </el-row>
        <el-row>
          <el-col>
            <!-- 附件 -->
            <el-form-item label="附件" prop="attachments" v-if="['CreateApply', 'CorrectApply'].indexOf(opera_type) === -1">
              <select-file-list v-if="apply_id" :insurance="attachment_name"
                                  object_type="group_insurance.insuranceapply" :object="apply_id"
                                  :file-list.sync="file_list" :allow-delete="opera_type !== 'ViewApply'"></select-file-list>
              <el-button type="primary" size="mini" @click="handleSelect">选择</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-if="['CreateApply', 'CorrectApply'].indexOf(opera_type) !== -1" @click="onSubmit('CreateApply')">立即创建</el-button>
              <el-button type="primary" v-if="['CreateApply', 'EditApply', 'CorrectApply'].indexOf(opera_type) !== -1" @click="UpdateShipInfo">同步船舶信息</el-button>
              <el-button type="primary" v-if="opera_type === 'EditApply'" @click="onSubmit('EditApply')">保存</el-button>
              <el-button type="primary" v-if="opera_type === 'SuccessApply'" @click="onSubmit('SuccessApply')">审核通过</el-button>
              <el-button type="primary" v-if="opera_type === 'SuccessApply'" @click="addSugDialog">审核不通过</el-button>
              <el-button @click="() => {this.$router.go(-1)}">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </el-collapse-item>
      <el-collapse-item title="相关文书" name="2" v-if="form.apply_type === 2">
          <el-col>
              <file-sign-list :attachments="sign_file_list" object_type="group_insurance.insuranceapply" :object_id="form.customer" :old_object_id="parent_form.customer"></file-sign-list>
          </el-col>
      </el-collapse-item>
    </el-collapse>
    </el-card>
    <select-file-dialog ref="select"
                        :object-name="form.ship_name"
                        :object-name-list="insured_list"
                        object-type="group_insurance.insuranceapply"
                        :file-type-list="file_type_list"
                        :object-id="apply_id"
                        :file-list.sync="file_list"
                        :ship-list="shipList" 
                        :customer-list="customerList"
                        :append-to-body="true"
                        :allowDelete="opera_type !== 'ViewApply'"
                        :allowSave="canSaveFile">
    </select-file-dialog>
    <contact-dialog ref="createContact" @updateContactList="updateContact"></contact-dialog>
    <el-dialog :visible.sync="SuggestionVisible" width="50%">
      <el-form ref="sug_form" :model="sug_form" label-width="120px">
        <el-form-item label="拒绝原因" width="50%">
          <el-input type="textarea"  :rows="10" v-model="sug_form.reason"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addMessage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getActivityList } from '@/api/group-insurance'
  import { CreateApply, UpdateApply, SuccessApply, RejectApply, fetchInsuranceApply, UpdateShipInfo,checkMember} from '@/api/group-insurance'
  import { fetchList as fetchShipList, fetchShipNameList} from '@/api/ship'
  import { fetchCustomerList,fetchCustomerContactList} from '@/api/customer'
  // import { fetchList as fetchContactList } from '@/api/contact'
  import { getShipCustomerBalance } from '@/api/member'
  import { fetchList as fetchGroupList, fetchGroupMember } from "@/api/group";
  import { fetchFileTypeList,fetchDictList, fetchInsuranceObjectNameFileList, fetchUserList } from "@/api/common"
  import { fetchFileList } from "@/utils";
  import SelectFileDialog from "@/components/SelectFileDialog"
  import SelectFileList from "@/components/SelectFileList"
  import ContactDialog from "../../br/customer/contact-dialog"
  import { GetShipInfo,getDues,getExpireDate,getShipJoinYear,getCustomerListByApply, getRiskPlans} from '@/api/group-insurance';
  import { match } from 'assert'
  import FileSignList from '@/components/FileSignListDetail'

  export default {
    name: "activity-apply",
    components: {
      SelectFileList,
      SelectFileDialog,
      ContactDialog,
      FileSignList
    },
    data() {
      var checkRemark = (rule, value, callback) => {
        if (value.content == undefined || value.content == null || value.content == "") {
          return callback(new Error("请选择开票情况"))
        }
        else {
          return callback()
        }
      };

      return {
        type_list: [],
        airworthiness_area_list:[],
        rules: {
          activity: [{required: true, message: '请选择活动', trigger: 'blur'}],
          department: [{required: true, message: '请选择业务部门', trigger: 'blur'}],
          referee: [{required: true, message: '请选择推荐人', trigger: 'blur'}],
          customer: [{required: true, message: '请选择会员', trigger: 'blur'}],
          ship: [{required: true, message: '请选择船舶', trigger: 'blur'}],
          append_date: [{required: true, message: '请输入参与年限', trigger: 'blur'}],
          join_date: [{required: true, message: '请选择入会日期', trigger: 'blur'}],
          dues: [{required: true, message: '请输入入会会费', trigger: 'blur'}],
          pay_gross_ton: [{required: true, message: '请输入缴费总吨', trigger: 'blur'}],
          remark: [{required: true, trigger: 'blur', validator: checkRemark}],
        },
        ship_info:{},
        activeNames: ["1", "2"],
        form: {
          append_date: 1,
          join_date: '',
          activity: '',
          department: '',
          big_begin_date: '',
          big_end_date: '',
          insured: '',
          customer: '',
          ship: '',
          content:'',
          dues: 0,
          referee: '',
          pay_gross_ton: 0,
          small_begin_date: '',
          small_end_date: '',
          balance: 0,
          remark: {"content": ''},
          contact: '',
          contact_mobile: '',
          change_content: '',
          small_change_content: '',
          small_rate: 0,
          is_verify_file: true,
          verify_file_msg: '',
          risk_premium_plans: (function() {
            let now = new Date()
            let currentDate = parseInt(`${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`)
            return currentDate >= 20260701 ? 2 : 1
          })(),
          max_compensation_plan: '',
        },
        apply_id: 0,
        big_rate_items: [4, 4.2],
        big_rate: 4.2,
        sign_file_list:[],
        risk_rate: 0.3,
        is_member_name:"",
        activities: [],
        customers: [],
        customerList:[],
        shipList:[],
        days:365,
        ships: [],
        is_member:false,
        expire_date:'',
        groupList: [],
        ship_file_list:[],
        small_rates: [1500, 3500],
        small_rate: '',
        loadingText: '正在加载数据，请稍等...',
        loading: false,
        delivery: false,
        select_atv: {},
        opera_type: "",
        file_list: [],
        contact_list: [],
        user_list: [],
        file_type_list: [],
        attachment_name: {'name': '附件'},
        SuggestionVisible:false,
        sug_form:{},
        ship_loading: false,
        customer_loading: false,
        invoice_items: [
          "1.全额开收据",
          "2.保费开专票，风险准备金开收据",
          "3.保费开专票，风险准备金开普票",
          "4.全额开普票",
          "5.保费开普票，风险准备金开收据"
        ],
        risk_premium: 0,
        sys_balance: 0,
        contact_loading: false,
        canEditActivity: true,
        parent_form: {},
        parent_id: '',
        is_correct: false,
        checked_file_list: [],
        insured_person_num: 0,
        insured_company_num: 0,
        insured_list: [],
        canSaveFile: false,
        canEditFinance: false,
        risk_premium_plan_list: [],
        max_compensation_choice: [
          "常规方案",
          "华翔方案"
        ],
        max_compensation: "",
        show_computed_value: false,
      }
    },
    watch: {
      risk_premium: {
        handler(newVal, oldVal){
          var total_tons = this.form.pay_gross_ton
          if (this.is_correct) {
            total_tons = total_tons - this.parent_form.pay_gross_ton
          }
          if (total_tons<=0) {
            this.risk_rate = 0
          } else {
            this.risk_rate = (newVal * this.days / total_tons / this.big_ins_period).toFixed(4)
          }
          const closestPlan = this.findClosestPlan(this.risk_rate)
          if (closestPlan && !this.form.risk_premium_plans) {
            this.form.risk_premium_plans = closestPlan.id
          }
        }
      },
      'form.insured': {
        handler(newVal, oldVal) {
          let insured_person_num = 0
          let insured_company_num = 0
          let insured = newVal
          if (insured) {
            insured = insured.replace(/，/g, ',').replace(/;/g, ',').replace(/；/g, ',').replace(/、/g, ',')
            this.insured_list = insured.split(',')
            this.insured_list.forEach(item => {
              if (item.length > 5) {
                insured_company_num += 1
              } else {
                insured_person_num += 1
              }
            })
          }
          this.insured_person_num = insured_person_num
          this.insured_company_num = insured_company_num
          this.update_checked_file_list(this.file_list, insured_person_num, insured_company_num)
        }
      },
      file_list : {
        handler(newVal, oldVal) {
          this.update_checked_file_list(newVal, this.insured_person_num, this.insured_company_num)
        },
        deep: true
      },
      must_file_list: {
        handler(newVal, oldVal) {
          this.update_checked_file_list(this.file_list, this.insured_person_num, this.insured_company_num)
        },
        deep: true
      },
      // 'form.pay_gross_ton'(val) {
      //   let total_tons = parseInt(val)
      //   this.payable_risk_premium = this.getRiskPremium(this.form.balance, total_tons)
      // },
      // 'form.balance'(val) {
      //   let total_tons = parseInt(this.form.pay_gross_ton)
      //   this.payable_risk_premium = this.getRiskPremium(val, total_tons)
      // },
      // big_ins_period:{
      //   handler(newVal, oldVal){
      //     var total_tons = this.form.pay_gross_ton
      //     if (total_tons > 0 && newVal > 0){
      //       this.payable_risk_premium = this.getRiskPremium(this.form.balance, total_tons)
      //     }
      //   },
      // }
    },
    computed: {
      // days() {
      //   var startDate = new Date(this.form.big_begin_date)
      //   var endDate = new Date(this.form.big_end_date)
      //   var days = 365

      //   if(startDate.getFullYear() % 4 == 0 && startDate.getFullYear() % 100 != 0 || startDate.getFullYear() % 400 ==0){
      //     console.log("开始日期年份是闰年")
      //     var special_day = startDate.getFullYear() + '-02-29'
      //     if (startDate > new Date(special_day)) {
      //       days = 365
      //     }
      //     else {
      //       days = 366
      //     }
      //   }
      //   else if (endDate.getFullYear() % 4 == 0 && endDate.getFullYear() % 100 != 0 || endDate.getFullYear() % 400 ==0) {
      //     console.log("结束日期年份是闰年")
      //     var special_day = endDate.getFullYear() + '-02-29'
      //     if (endDate < new Date(special_day)) {
      //       days = 365
      //     }
      //     else {
      //       days = 366
      //     }
      //   }
        
      //   return days
      // },
      max_compensation_value() {
        var amount = 0
        if (this.max_compensation == "华翔方案") {
          if (this.ship_info.gross_tonnage < 500) {
            amount = 500
          }
          else if (this.ship_info.gross_tonnage >= 1000) {
            amount = 2000
          }
          else {
            amount = 1500
          }
        } else {
          if (this.form.pay_gross_ton == 500) {
            amount = 500
          }
          else if (this.form.pay_gross_ton == 1500) {
            if (this.ship_info.gross_tonnage == 1500) {
              amount = 2000
            }
            else {
              amount = 1800
            }
          }
          else if (this.form.pay_gross_ton > 1500) {
            amount = 2000
          }
          else {
            amount = (this.form.pay_gross_ton * 1.2).toFixed(2)
          }
        }
        return amount
      },
      big_ins_period() {
        var startDate = Date.parse(this.form.big_begin_date)
        var endDate = Date.parse(this.form.big_end_date)
        var period = Math.round((endDate - startDate) / (1*24*60*60*1000)) + 1
        // period = days + 1

        return period
      },
      small_ins_period() {
        var period = 0
        var startDate = Date.parse(this.form.small_begin_date)
        var endDate = Date.parse(this.form.small_end_date)

        // console.log(startDate, endDate)

        if (!isNaN(startDate) && !isNaN(endDate) && (startDate < endDate)) {
          var days = Math.round((endDate - startDate) / (1*24*60*60*1000))
          period = days + 1
        }
        return period
      },
      big_premium() {
        var premium = 0
        var total_tons = this.form.pay_gross_ton
        if (this.is_correct) {
          total_tons = total_tons - this.parent_form.pay_gross_ton
        }
        if (total_tons > 0 && this.big_ins_period > 0) {
          premium = total_tons * this.big_rate * this.big_ins_period / this.days
        }
        return premium.toFixed(2)
      },
      small_premium() {
        var premium = 0
        var small_rate = this.form.small_rate
        if (this.is_correct) {
          small_rate = small_rate - this.parent_form.small_rate
        }
        if (small_rate > 0 && this.small_ins_period > 0) {
          premium = small_rate * this.small_ins_period / this.days
        }
        return premium.toFixed(2)
      },
      parent_form_small_rate() {
        var parent_form_small_rate = 0
        if (this.is_correct && this.parent_form.parent_small_rate > 0) {
          parent_form_small_rate = this.parent_form.parent_small_rate
        }
        return parent_form_small_rate
      },
      total_amount() {
        let big_premium = Number(this.big_premium)
        let small_premium = Number(this.small_premium)
        let risk_premium = Number(this.risk_premium)
        let dues = Number(this.form.dues)
        return (big_premium + small_premium + risk_premium + dues).toFixed(2)
      },
      diff_premium() {
        return (this.risk_premium - this.payable_risk_premium).toFixed(2)
      },
      payable_risk_premium() {
        var payable_risk_premium = 0
        if (this.form.pay_gross_ton && this.form.pay_gross_ton > 0) {
          let pay_gross_ton = parseInt(this.form.pay_gross_ton)
          if (this.is_correct) {
            pay_gross_ton = pay_gross_ton - this.parent_form.pay_gross_ton
          }
          if (pay_gross_ton <= 0) {
            return 0
          }
          let balance = this.form.balance
          let paid_risk_premium_per_ton = balance / parseInt(this.form.pay_gross_ton)
          let risk_premium_plan = this.risk_premium_plan_list.find(plan => plan.id == this.form.risk_premium_plans);
          // console.log("this.form.risk_premium_plans:", this.form.risk_premium_plans)
          // console.log("risk_premium_plan:", risk_premium_plan)

          var per_year_premium = 0.3, per_ton_premium = 2
          if (risk_premium_plan) {
            per_year_premium = risk_premium_plan.rate
            per_ton_premium = risk_premium_plan.max_rate
          }
          else if (this.form.big_begin_date >= '2024-09-01') {
            per_year_premium = 0.3
            per_ton_premium = 0.3
          } else if (this.form.big_begin_date >= '2024-03-16') {
            per_year_premium = 0.3
            per_ton_premium = 1.5
          } else {
            per_year_premium = 0.4
            per_ton_premium = 2
          }
          if (paid_risk_premium_per_ton >= per_ton_premium) {
            payable_risk_premium = 0
          } else {
            payable_risk_premium = Math.min(parseInt(this.form.pay_gross_ton) * per_ton_premium - balance, pay_gross_ton * per_year_premium / this.days * this.big_ins_period).toFixed(2)
          }
        }
        return payable_risk_premium
      },
      must_file_list() {
        let must_file_type_code_list = [
          {
            name: '船舶检验证书',
            code: 'sc_inspection'
          },
          {
            name: '所有权证书',
            code: 'sc_ownership_certificate'
          },
          {
            name: '国籍证书',
            code: 'sc_nationality'
          },
          {
            name: '最低配员证书',
            code: 'sc_minimum_manning'
          },
          {
            name: '被保险人证件',
            id_code: ['sc_id_card', 'cc_id_card'],
            business_code: ['sc_business_license', 'cc_org_code', 'cc_business_reg', 'cc_business_license', 'cc_credit_code']
          }
        ]
        if (this.ship_info.airworthiness_area === '6') {
          must_file_type_code_list.push({
            name: '港澳航线证明',
            code: 'sc_hk_mc'
          })
        }
        if (this.delivery) {
          must_file_type_code_list.push({
            name: '小桥梁险投保单',
            code: 'af_qlx'
          })
        }
        return must_file_type_code_list
      },
      checked_must_file() {
        let val = true
        this.must_file_list.forEach(item => {
          if (this.checked_file_list.indexOf(item.name) === -1) {
            val = false
            return
          }
        })
        return val
      }
    },
    methods: {
      autoCalculateBigRate() {
        let big_rate = 4.2
        if (this.select_atv) {
          if (parseInt(this.select_atv.year) >= 2026 && this.select_atv.activity_periods_detail > 1) {
            big_rate = 4
          }
        }
        this.big_rate = big_rate
      },
      handleMaxCompensationChange(val) {
        // console.log(val)
        this.show_computed_value = true
        this.form.max_compensation_value = this.max_compensation_value
        this.form.max_compensation_plan = this.max_compensation
      },
      restricted_mobile(mobile) {
        if (mobile && !this.$perm(['contact.list_contact']) && !this.$perm(['contact.all_contact']) && this.$perm(['contact.restricted_list_contact'])) {
          let value = mobile.slice(0, 3)
          var l = mobile.slice(3, 7).length
          for (var i=0; i<l; i++) {
            value += '*'
          }
          value += mobile.slice(7)
          return value
        }
        return mobile
      },
      update_checked_file_list(file_list, insured_person_num, insured_company_num) {
        let must_file_type_code_list = this.must_file_list
        let val = []
        let id_file_name_list = []
        let business_file_name_list = []
        must_file_type_code_list.forEach(item => {
          if (item.name === '被保险人证件') {
            file_list.forEach(item2 => {
              if (item2.checked) {
                if (item.id_code.indexOf(item2.file_type) !== -1) {
                  this.insured_list.forEach(insured_item => {
                    if (item2.name.indexOf(insured_item) !== -1 && id_file_name_list.indexOf(insured_item) === -1) {
                      id_file_name_list.push(insured_item)
                    }
                  })
                } else if (item.business_code.indexOf(item2.file_type) !== -1) {
                  this.insured_list.forEach(insured_item => {
                    if (item2.name.indexOf(insured_item) !== -1 && business_file_name_list.indexOf(insured_item) === -1) {
                      business_file_name_list.push(insured_item)
                    }
                  })
                }
              }
            })
            if (id_file_name_list.length >= insured_person_num && business_file_name_list.length >= insured_company_num) {
              val.push('被保险人证件')
            }
          } else {
            file_list.forEach(item2 => {
              if (item2.checked) {
                if (item2.checked && item.code === item2.file_type && val.indexOf(item.name) === -1) {
                  val.push(item.name)
                }
              }
            })
          }
        })
        this.checked_file_list = JSON.parse(JSON.stringify(val))
      },
      findClosestPlan(risk_rate) {
        let minDiff = Infinity;
        let closestPlan = null;

        for (let plan of this.risk_premium_plan_list) {
          const diff = Math.abs(plan.rate - risk_rate);
          if (diff < minDiff) {
            minDiff = diff;
            closestPlan = plan;
          }
        }

        return closestPlan;
      },
      handleContactInfo(index){
        // let contact = this.contact_list.find((a) => { return a.name === this.form.contact })
        this.form.contact_mobile = this.contact_list[index].mobile
      },
      getRiskPremium(balance, pay_gross_ton) {
        let risk_premium = 0
        let paid_risk_premium_per_ton = balance / pay_gross_ton
        if (paid_risk_premium_per_ton >= 2) {
          risk_premium = 0
        } else {
          risk_premium = Math.min(pay_gross_ton * 2 - balance, pay_gross_ton * 0.4 / this.days * this.big_ins_period).toFixed(2)
        }
        return risk_premium
      },
      usePayableRiskPremium() {
        this.risk_premium = this.payable_risk_premium
      },
      useSysBalance() {
        this.form.balance = this.sys_balance
      },
      getShipInfoDetail(){
        let form_data = JSON.parse(JSON.stringify(this.form))
        GetShipInfo({'ship':form_data.ship})
        .then(resp => {
          this.ship_info = resp.result
        })
        .catch(error => {
          this.loading = false
          this.$message.error(error)
        })
      },
      UpdateShipInfo(){
        this.ship_info.id = this.form.ship
        UpdateShipInfo(this.ship_info)
              .then(res => {
                this.$message.success("船舶信息已更新")
              })
              .catch(err => {
                this.$error_message(err)
              })

      },
      addMessage() {
        this.sug_form.apply_id = this.apply_id
        RejectApply(this.sug_form)
          .then(res => {
            this.$message.success("拒绝成功")
            this.SuggestionVisible = false
            this.$router.push({name: 'ApplyInsurance'})
          })
          .catch(err => {
            this.$error_message(err)
          })
      },
      addSugDialog() {
      this.SuggestionVisible = true
      },
      loadData() {
        this.loading = true
        let p = []
        if ((["ViewApply", "SuccessApply"].indexOf(this.opera_type) !== -1)){
          p.push(getActivityList({near:3, applyId:this.apply_id}))  // 获取当前申请的活动
        }
        else if ((["EditApply", "CorrectApply"].indexOf(this.opera_type) !== -1)) {
          p.push(getActivityList({near:2}))     // 获取保险期限未过期的活动
        }
        else{
          p.push(getActivityList({near:1}))     // 获取可以报名的活动
        }
        
        p.push(fetchGroupList({type:"group_apply"}))
        p.push(fetchFileTypeList({file_type: "group_ins|sc|cc|bc"}))
        p.push(fetchDictList({type: "ship.type"}));
        p.push(fetchDictList({type: "ship.airworthiness_area"}));
        p.push(fetchUserList())
        p.push(getRiskPlans())
        

        Promise.all(p)
        .then(res => {
          this.activities = res[0]
          // this.ships = res[1]
          // this.customers = res[2]
          this.groupList = res[1]
          this.file_type_list = res[2]
          this.type_list = res[3]
          this.airworthiness_area_list = res[4]
          this.user_list = res[5]
          this.risk_premium_plan_list = res[6]
        })
        .then(() => {
          getCustomerListByApply({id:this.id})
              .then(res => {
                this.customerList = res
              })
              .catch(err => {
                this.$error_message(err)
              })
          if (["ViewApply", "EditApply", "SuccessApply", "CorrectApply"].indexOf(this.opera_type) !== -1) {
            let apply_id = ''
            if (this.opera_type === 'CorrectApply') {
              apply_id = this.parent_id
              this.is_correct = true
            } else {
              apply_id = this.apply_id
            }
            getCustomerListByApply({id:apply_id})
              .then(res => {
                this.customerList = res
              })
              .catch(err => {
                this.$error_message(err)
              })
            fetchInsuranceApply(apply_id).then(async resp => {
              let is_exist = false
              let ship_obj = {"id":resp.ship,"name":resp.ship_name}
              this.customerList.forEach(item => {
                  if (item.id === resp.customer) {
                    is_exist = true
                  }
                })
              if ( is_exist === false){
                let customer_obj = {"id":resp.customer,"name":resp.customer_name}
                this.customerList.push(customer_obj)
              }
  
              this.shipList.push(ship_obj)
              this.form.append_date = resp.append_date,
              this.form.join_date = resp.join_date,
              this.form.department = resp.department,
              this.form.referee = resp.referee,
              // this.form.referee = this.user_list.find(u => u.id==resp.referee),
              this.form.big_begin_date = resp.big_begin_date,
              this.form.big_end_date = resp.big_end_date,
              this.form.insured = resp.insured
              let insured = this.form.insured
              if (insured) {
                insured = insured.replace(/，/g, ',').replace(/;/g, ',').replace(/；/g, ',').replace(/、/g, ',')
                this.insured_list = insured.split(',')
              }
              this.form.dues = resp.dues,
              this.form.pay_gross_ton = resp.pay_gross_ton,
              this.form.small_begin_date = resp.small_begin_date,
              this.form.small_end_date = resp.small_end_date
              this.form.is_verify_file = resp.is_verify_file
              this.form.verify_file_msg = resp.verify_file_msg

              this.select_atv = this.activities.find((a) => {return a.id === resp.activity})
              if (this.small_ins_period > 0) {
                this.delivery = true
              }
              this.form.activity = resp.activity
              this.form.customer_name = resp.customer_name
              this.remoteCustomerMethod(resp.customer_name)
              this.remoteShipMethod(resp.ship_name)
              this.form.customer = resp.customer
              this.form.ship = resp.ship
              this.form.ship_name = resp.ship_name
              this.form.balance = resp.balance
              this.form.remark = resp.remark
              this.form.contact = resp.contact
              this.form.content = resp.content
              this.form.contact_mobile = resp.contact_mobile
              this.form.risk_premium_plans = resp.risk_premium_plans ? resp.risk_premium_plans : 1
              this.form.small_rate = resp.small_rate
              if (this.opera_type === 'CorrectApply') {
                this.form.parent = apply_id
                this.form.apply_type = 2
              } else {
                this.form.parent = resp.parent
                this.form.apply_type = resp.apply_type
                this.parent_id = resp.parent
                this.form.change_content = resp.change_content
                this.form.small_change_content = resp.small_change_content
                this.loadFileList('group_insurance.insuranceapply', this.apply_id)
              }
              if (this.form.apply_type === 2) {
                this.is_correct = true
                await this.fetchParentApply(this.parent_id)
              }
              this.handleAtvInfo(this.select_atv.id)
              // this.small_premium = resp.small_premium
              this.big_rate = resp.big_rate || 4.2
              this.risk_premium = resp.risk_premium
              // this.risk_rate = (this.risk_premium * this.days / this.form.pay_gross_ton / this.big_ins_period).toFixed(4)
              this.form.max_compensation_value = resp.max_compensation_value
              this.form.max_compensation_plan = resp.max_compensation_plan

              this.attachment_name.name = resp.ship_name + '-' + resp.year + '年' + resp.activity_name
              this.getShipInfoDetail()
              this.getBalance()
              if (this.opera_type === 'EditApply' && ([0, 3].indexOf(resp.status) === -1 || resp.finance !== null || resp.registration !== null || resp.apply_type === 2)) {
                this.canEditActivity = false
              }
              if ([0, 3].indexOf(resp.status) !== -1) {
                this.canSaveFile = true
              }
              if (resp.finance !== null && ["CorrectApply"].indexOf(this.opera_type) === -1) {
                this.canEditFinance = true
              }
          //     fetchCustomerContactList(this.form.customer)
          //     .then(res => {
          //         this.contact_list = res
          //         console.log(this.contact_list)
          //     })
          //     .catch(err => {
          //       this.$error_message(err)
          // })
            })
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$error_message(err)
        })
      },
      async fetchParentApply(parent_id) {
        return new Promise((resolve, reject) => {
          fetchInsuranceApply(parent_id).then(resp => {
            this.parent_form = resp
            resolve(resp)
          }).catch(err => {
            reject(err)
          })
        })
      },
      handleChangeBigBeginDate(value) {
        if (this.delivery) {
          this.form.small_begin_date = value
        }
      },
      handleAtvInfo(item) {
        if (["ViewApply", "EditApply", "SuccessApply", "CorrectApply"].indexOf(this.opera_type) === -1 && item && this.form.customer !== ''){
          getDues({'customer':this.form.customer,'activity':item})
          .then(res => {
              this.form.dues = res.dues
          })
          .catch(err => {
            this.$error_message(err)
          })
        }
        this.select_atv = this.activities.find((a) => {return a.id === item})
        if (!this.is_correct) {
          this.form.big_begin_date = this.select_atv.insurance_begin_date
          this.form.big_end_date = this.select_atv.insurance_end_date
          if (this.select_atv.insurance_begin_date >= '2026-07-01'){
            this.form.risk_premium_plans = 2
          }
          else {
            this.form.risk_premium_plans = 1
          }
        }
        this.handleSmallInfo()
        this.days = this.select_atv.days
        this.autoCalculateBigRate()
      },
      handleShipInfo(item) {
        this.getShipInfoDetail()
        let ship = this.ships.find((a) => {return a.id === item})
        if ((ship.gross_tonnage !== 'null') && (ship.gross_tonnage !== 'undefined') && (ship.gross_tonnage >= 500)) {
          this.form.pay_gross_ton = ship.gross_tonnage
        }
        else {
          this.form.pay_gross_ton = 500
        }
        this.getBalance()
        this.ShipJoinYear()
      },

      ShipJoinYear(){
        if(this.form.ship && this.form.customer && this.opera_type === 'CreateApply'){
          getShipJoinYear({'customer_id': this.form.customer, 'ship_id': this.form.ship}).then(res => {
            this.form.append_date = res.count
          }).catch(err => {
            this.$error_message(err)
          })
        }
      },
      getBalance() {
        if (this.form.ship && this.form.customer) {
          getShipCustomerBalance({'customer_id': this.form.customer, 'ship_id': this.form.ship}).then(res => {
            this.sys_balance = res.balance
          }).catch(err => {
            this.$error_message(err)
          })
        }
      },
      handleCustomerInfo(item) {
        getExpireDate({'customer':item})
          .then(res => {
              this.is_member = res.is_member
              this.expire_date = res.expire_date
              if (this.is_member){
                this.is_member_name = '是'
              }
              else {
                this.is_member_name = '否'
              }

          })
          .catch(err => {
            this.$error_message(err)
          })

        if (item && this.form.activity !== ''){
          getDues({'customer':item,'activity':this.form.activity})
          .then(res => {
              this.form.dues = res.dues
          })
          .catch(err => {
            this.$error_message(err)
          })
        }

        // fetchCustomerContactList(item)
        //   .then(res => {
        //       this.contact_list = res
        //       console.log(this.contact_list)
        //   })
        //   .catch(err => {
        //     this.$error_message(err)
        //   })
        this.getBalance()
        this.ShipJoinYear()
        this.$forceUpdate()       
      },
      handleSmallInfo() {
        // console.log(this.delivery,'发生变化')
        if (this.delivery == false) {
          this.small_rate = ''
          this.form.small_rate = 0
          this.form.small_begin_date = ''
          this.form.small_end_date = ''
        } 
        else if (this.form.big_begin_date && this.form.big_end_date && (this.form.small_begin_date === '' || this.form.small_end_date === '')) {
          this.form.small_begin_date = this.form.big_begin_date
          this.form.small_end_date = this.form.big_end_date
        }
      },
      handleUpload() {
        this.$refs.upload.handleOpen()
      },
      loadFileList(object_type, object_id) {
        let exist_list = []
        let sign_file_list = []
        let not_list = ['af_ar','af_pi','af_eli']
        let sign_file_list_name = ["委托授权书.pdf","船舶批改申请书.pdf","船舶替换申请书","船舶信息变更申请书"]
        let insured_type_list = ['sc_id_card', 'cc_id_card', 'sc_business_license', 'cc_org_code', 'cc_business_reg', 'cc_business_license', 'cc_credit_code']
        let p = []
        p.push(fetchFileList(object_type, object_id, this.file_type_list))
        p.push(fetchFileList("ship.ship", this.form.ship, this.file_type_list))
        p.push(fetchInsuranceObjectNameFileList("customer.customer", this.insured_list.join('|')))
        Promise.all(p)
          .then(res => {
            let file_list = res[0].file_list
            file_list.forEach(item => {
              exist_list.push(item.id)
              this.$set(item, 'checked', true)
            })
            // file_list.forEach(item => {
            //   if (sign_file_list_name.indexOf(item.name) !== -1){
            //     sign_file_list.push(item)
            //   }
            // })
            sign_file_list = file_list.filter(file => {  
              // 使用some方法来检查文件名是否包含sign_file_list_name中的任何一个字符串  
              return sign_file_list_name.some(name => file.name.includes(name));  
            });  
            this.ship_file_list = res[1].file_list;
            this.ship_file_list.forEach(item => {
              this.$set(item, 'checked', false)
              if (not_list.indexOf(item.file_type) === -1 && exist_list.indexOf(item.id) === -1){
                file_list.push(item)
              }
              // this.$set(item, 'checked', true)
              exist_list.push(item.id)
              
            })
            let insured_file_list = res[2];
            insured_file_list.forEach(item => {
              this.$set(item, 'checked', false)
              if (insured_type_list.indexOf(item.file_type) !== -1 && exist_list.indexOf(item.id) === -1){
                file_list.push(item)
              }
              // this.$set(item, 'checked', true)
              exist_list.push(item.id)
              
            })
            // this.default_issue_date = res.def_issue_date;
            // this.default_expire_date = res.def_expire_date;
            this.file_list = file_list
            this.sign_file_list = sign_file_list
            this.$forceUpdate()
          })
          .catch(error => {
            this.$error_message(error);
          });
        // fetchFileList("ship.ship", this.form.ship, this.file_type_list)
        //   .then(res => {
        //     this.ship_file_list = res.file_list;
        //     this.ship_file_list.forEach(item => {
        //       this.$set(item, 'checked', false)
        //       if (not_list.indexOf(item.file_type) === -1 && exist_list.indexOf(item.id) === -1){
        //         this.file_list.push(item)
        //       }
        //       // this.$set(item, 'checked', true)
        //       exist_list.push(item.id)
              
        //     })
        //     // this.default_issue_date = res.def_issue_date;
        //     // this.default_expire_date = res.def_expire_date;
        //   })
        //   .catch(error => {
        //     this.$error_message(error);
        //   });
        // fetchFileList("ship.ship", this.form.ship, this.file_type_list)
        //   .then(res => {
        //     this.ship_file_list = res.file_list;
        //     this.ship_file_list.forEach(item => {
        //       if (not_list.indexOf(item.file_type) === -1 && exist_list.indexOf(item.id) === -1){
        //         this.file_list.push(item)
        //       }
        //     })
        //     // this.default_issue_date = res.def_issue_date;
        //     // this.default_expire_date = res.def_expire_date;
        //   })
        //   .catch(error => {
        //     this.$error_message(error);
        //   });
      },
      onSubmit(option) {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.form.big_rate = this.big_rate
            this.form.big_premium = this.big_premium
            this.form.small_premium = this.small_premium
            this.form.risk_premium = this.risk_premium
            this.form.total_amount = this.total_amount
            // this.form.max_compensation_value = this.max_compensation_value

            if (option === 'CreateApply') {
              CreateApply(this.form)
              .then(res => {
                this.$message.success("创建申请成功")
                setTimeout(() => {
                    this.$router.push({name: 'ApplyInsurance'})
                  }, 500)
              })
              .catch(err => {
                this.$error_message(err)
              })
            }
            else if (option === 'EditApply') {
              this.form.id = this.apply_id
              this.form.file_list = this.file_list
              UpdateApply(this.form)
              .then(res => {

                this.$message.success("参保信息已更新")
                setTimeout(() => {
                    this.$router.push({name: 'ApplyInsurance'})
                  }, 500)
              })
              .catch(err => {
                this.$error_message(err)
              })
            }
            else if (option === 'SuccessApply') {
              checkMember({'customer':this.form.customer,'department':this.form.department}) .then(res => {
                      if (res.count === 1){
                        var msg = '检测到该会员已经归属 '+ res.dept +'或部门'+ res.dept+'正在申请,'  +'是否共享 ？'
                        this.$confirm(msg, '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'info'
                        }).then(() => {
                            SuccessApply({id: this.apply_id,'risk_premium':this.risk_premium,'ship':this.form.ship,'customer':this.form.customer,'department':this.form.department})
                            .then(res => {
                              this.$message.success(res)
                              setTimeout(() => {
                                  this.$router.push({name: 'ApplyInsurance'})
                                }, 500)
                            })
                            .catch(err => {
                              this.$error_message(err)
                            })
                        })
                      }
                      else{
                        SuccessApply({id: this.apply_id,'risk_premium':this.risk_premium,'ship':this.form.ship,'customer':this.form.customer,'department':this.form.department})
                              .then(res => {
                                this.$message.success(res)
                                setTimeout(() => {
                                    this.$router.push({name: 'ApplyInsurance'})
                                  }, 500)
                              })
                              .catch(err => {
                                this.$error_message(err)
                              })
                      }
                  })
                  .catch(err => {
                    this.$error_message(err)
              })
           }
          }
        })
      },
      handleSelect() {
        this.$refs.select.handleSelect()
      },
      remoteCustomerMethod(query) {
        if (query !== '') {
          this.customer_loading = true
          setTimeout(() => {
            fetchCustomerList({'search': query}).then(res => {
              this.customers = res
              this.customer_loading = false
            }).catch(err => {
              this.customer_loading = false
              this.$error_message(err)
            })
          }, 200);
        } else {
          this.customers = [];
        }
      },
      remoteShipMethod(query) {
        if (query !== '') {
          this.ship_loading = true
          setTimeout(() => {
            fetchShipNameList({'search': query}).then(res => {
              this.ships = res
              this.ship_loading = false
            }).catch(err => {
              this.ship_loading = false
              this.$error_message(err)
            })
          }, 200);
        } else {
          this.ships = [];
        }
      },
      handCreateContact() {
        this.$refs.createContact.handleOpen()
      },
      updateContact(contact) {
        this.form.contact = contact.name
        this.form.contact_mobile = contact.mobile
      },
      remoteContactMethod(query) {
        if (!this.form.customer || !this.form.department) {
          this.$message.error('请先选择业务部门和会员')
          return
        }
        if (query !== '') {
          this.contact_loading = true
          setTimeout(() => {
            fetchCustomerContactList(this.form.customer, {'department': this.form.department}).then(res => {
              this.contact_list = res
              this.contact_loading = false
            }).catch(err => {
              this.contact_loading = false
              this.$error_message(err)
            })
          }, 200);
        } else {
          this.contact_list = [];
        }
      },
    },
    beforeRouteLeave (to, from, next) {
        if (to.name != 'ApplyInsurance') {
          window.localStorage.removeItem('query')
        }
        next()
        },
    created() {
      this.opera_type = this.$route.query.type

      if (this.$route.query.type === undefined ||
      ((["ViewApply", "EditApply", "SuccessApply"].indexOf(this.opera_type) !== -1) && this.$route.query.id === undefined)){
        this.$router.push('/404')
      }

      this.apply_id = this.$route.query.id

      if ((["CorrectApply"].indexOf(this.opera_type) !== -1) && this.$route.query.parent_id === undefined) {
        this.$router.push('/404')
      }

      this.parent_id = this.$route.query.parent_id
      this.loadData()
      
      // if (this.opera_type === "EditApply"){
      //   this.getShipInfoDetail()
      // }
    }
  }
</script>
